import { render } from "./Related.vue?vue&type=template&id=50001752&scoped=true"
const script = {}

import "./Related.vue?vue&type=style&index=0&id=50001752&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50001752"

export default script